<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header :title="getTitle" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
                <mt-button slot="right"  @click="onDelete" v-if="!isAddMode">Delete</mt-button>
            </mt-header>
        </div>
        <div class="">
            <div v-if="!isAddMode">
                <mt-cell title="门店账号" :value="chain.chain_name"></mt-cell>
            </div>
            <mt-field v-else label="门店账号" v-model="chain.chain_name"></mt-field>
            <mt-field label="门店密码" v-model="chain.chain_passwd"  type="password"></mt-field>
            <mt-field label="门店名称" v-model="chain.chain_addressname"></mt-field>
            <mt-field label="联系人姓名" v-model="chain.chain_truename" type="phone"></mt-field>
            <mt-field label="联系人手机" v-model="chain.chain_mobile" type="phone"></mt-field>
            <mt-field label="座机" v-model="chain.chain_telephony" type="email"></mt-field>
            <div @click="onRegion">
            <mt-cell title="地区" is-link>
                    <span>{{chain.chain_area_info}}</span>
            </mt-cell>
            </div>
            <mt-cell class="input-wrap" title="地址"><input class="text" type="text" v-model="chain.chain_address"><i class="iconfont" @click="popMap=true;getPosition()">&#xe6d3;</i></mt-cell>
            <mt-cell title="门店状态">
                <mt-switch v-model="chain.chain_state"></mt-switch>
            </mt-cell>
            <mt-cell title="开启自提">
                <mt-switch v-model="chain.chain_if_pickup"></mt-switch>
            </mt-cell>
            <mt-cell title="开启代收">
                <mt-switch v-model="chain.chain_if_collect"></mt-switch>
            </mt-cell>
            <mt-button class="ds-button-large mt-10" type="primary" v-on:click="submit">Submit</mt-button>
        </div>
        <region-picker ref="picker" v-on:onConfirm="onPickerConfirm"></region-picker>
        <mt-popup v-model="popMap" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="定位" class="common-header">
                    <mt-button slot="left" icon="back" @click="popMap=false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <map-select ref="map_select" :longitude="chain.chain_longitude" :latitude="chain.chain_latitude" @setPosition="setPosition"></map-select>
            </div>
        </mt-popup>
    </div>
</template>

<script>
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { getPointByAddress } from '../../../util/bmap'
import { getChainInfo, delChain, addChain, editChain } from '../../../api/sellerChain'
import RegionPicker from '../../../components/RegionPicker'
import MapSelect from '../../../components/MapSelect'
export default {
  name: 'ChainForm',
  components: {
    RegionPicker,
    MapSelect
  },
  data () {
    return {
      popMap: false,
      chain_id: 0,
      chain: {
        chain_state: true,
        chain_if_pickup: true,
        chain_if_collect: true
      }
    }
  },
  created: function () {
    if (!this.isAddMode) {
      this.chain_id = this.$route.query.chain_id
      getChainInfo({ chain_id: this.chain_id }).then(res => {
        let chain = res.result.chain_info
        chain.chain_passwd = ''
        chain.chain_state = !!chain.chain_state
        chain.chain_if_pickup = !!chain.chain_if_pickup
        chain.chain_if_collect = !!chain.chain_if_collect
        this.chain = chain
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  computed: {
    isAddMode () {
      let mode = this.$route.query.action
      // add: 添加门店，edit: 编辑门店
      if (mode === 'add') {
        return true
      } else {
        return false
      }
    },
    getTitle () {
      if (this.isAddMode) {
        return '新增门店'
      } else {
        return '修改门店'
      }
    }
  },
  methods: {
    getPosition () {
      getPointByAddress(this.chain.chain_area_info + this.chain.chain_address).then(res => {
        if (res.result.location) {
          this.chain.chain_longitude = res.result.location.lng
          this.chain.chain_latitude = res.result.location.lat
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    setPosition (lat, lng, name) {
      this.popMap = false
      this.chain.chain_address = name
      this.chain.chain_longitude = lng
      this.chain.chain_latitude = lat
    },
    onRegion (picker, values) {
      this.$refs.picker.currentValue = true
    },
    onPickerConfirm (values) {
      this.chain.chain_area_info = this.getRegionStr(values)

      this.chain.chain_area_3 = values[2].area_id
      this.chain.chain_area_2 = values[1].area_id
      this.$forceUpdate()
    },
    getRegionStr (values) {
      let title = ''
      for (let i = 0; i < values.length; i++) {
        const element = values[i]
        if (i !== 0) {
          title = title + ' ' + element.area_name
        } else {
          title = title + element.area_name
        }
      }
      return title
    },
    onDelete () {
      MessageBox.confirm('确定要删除该门店吗？').then(action => {
        delChain({chain_id:this.chain_id}).then(
          (response) => {
            this.$router.push({ name: 'SellerChainList' })
          }, (error) => {
            Toast(error.message)
          })
      })
    },
    submit () {
      if (this.isAddMode) {
        Indicator.open()
        addChain(this.chain).then(
          (response) => {
            Indicator.close()
            Toast(response.message)
            this.$router.push({ name: 'SellerChainList' })
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      } else {
        Indicator.open()
        editChain(this.chain).then(
          (response) => {
            Indicator.close()
            Toast(response.message)
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      }
    }
  }

}
</script>

<style scoped>
    .text{text-align: right;border: 0}
</style>
